/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для контакта пользователя в кабинете
   */
  app.UserDataContactView = app.FormView.extend({
    childViews: {},
    formElement: '.contact-field',
    removed: false,
    events: {
      'click .remove-contact': 'removeView'
    },
    run: function () {
      app.FormView.prototype.run.apply(this);
      this.template = app.helpers.TemplateHelper.getTemplate('#user-contact-view-template');
      this.initSelect();
      this.initPhoneMask();
      this.listenTo(this.model, 'change:contact_type_id', this.render);
    },
    render: function () {
      this.$el.html(this.template({model: this.model}));
      this.updateFieldsList();
      this.initSelect();
      this.initPhoneMask();
      return this;
    },
    save: function () {
      var that = this;
      this.model.save(
        this.getData(),
        {
          'success': function () {
            that.success('success-user-contact-view');
          },
          'error': this.error.bind(this),
          'wait': true
        }
      );
      this.childViews.phoneMask && this.childViews.phoneMask.save();
    },
    /**
     * Удаляет поле для ввода телефона
     */
    removeView: function () {
      this.remove();
      this.removed = true;
    },
    /**
     * Удаляет модель телефона
     */
    removeModel: function () {
      this.model.destroy();
      this.trigger('remove-user-contact-view');
    },
    /**
     * Инициализация поля выбора типа контакта.
     */
    initSelect: function () {
      var select = this.$('.select');
      if (select.length) {
        this.childViews.selectView = new app.SelectView({
          el: this.$('.select'),
          model: this.model,
          activeValueSelector: '.select_active',
          field: 'contact_type_id',
          inputSelector: 'input',
          optionsSelector: '.js-options'
        });
        this.childViews.selectView.renderActiveValue();
      }
    },
    /**
     * Инициализация маски поля ввода номера телефона.
     */
    initPhoneMask: function () {
      var flags = this.$('.choice-country'),
        input = this.$('.input_phone'),
        number,
        model;
      if (flags.length && input.length) {
        model = app.countryFlag.clone();
        model.unset('id');
        if (input.val()) {
          number = input.val();
          model.unset('id').set(app.helpers.PhoneHelper.getCountryCodeFromNumber(number));
        }
        new app.ChoiceCountryView({'el': flags, model: model});
        this.childViews.phoneMask = new app.PhoneInputmaskView({el: input, model: model});
      }
    },
    /**
     * Заполнение ошибок
     * @param {array} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      var that = this;

      errors.forEach(function (error) {
        that.$('.error-message').text(error.message);
        that.$('[name=' + error.field + ']').addClass('error');
      });
    },
  });
})(jQuery);

}.call(window));